export const setupCopyDe = {
    yourHospitalNumber: "Ihre Krankenhausnummer",
    hospitalNumberIntro:
        "Ihre Krankenhausnummer hilft, Sie im Krankenhaussystem zu identifizieren. Wenn Ihr Behandler Ihnen eine Nummer zugewiesen hat, geben Sie diese bitte hier ein.",
    hospitalNumberFieldHint: "Das hilft, Sie im Krankenhaussystem zu identifizieren.",
    dontKnow: "Ich weiß es nicht",
    skipForNow: "Ich weiß es noch nicht",
    whichSideAffectedTitle: "Welche Körperseite ist betroffen?",
    sideSetupLeadInTrackersOnly:
        "Wir müssen wissen, welche Körperseite betroffen ist, damit wir Ihnen die richtigen Fragen für folgende Fragebögen stellen können: ",
    sideSetupLeadInProceduresOnly:
        "Wir müssen wissen, welche Körperseite betroffen ist, damit wir dies zuordnen können: ",
    sideSetupLeadInBoth:
        "Wir müssen wissen, welche Körperseite betroffen ist, damit wir Ihnen die richtigen Fragen für folgende Fragebögen und Ihre Behandlung stellen können: ",
    sideSetupBothSidesNote:
        "Wenn beide Seiten betroffen sind, wählen Sie Beidseitig. Wir fügen dann für jede Seite einen Fragebogen hinzu.",
    saveDate: "Datum speichern",
    pickDate: "Datum wählen",
    clearDateAndTime: "Datum und Uhrzeit löschen",
    missingReferenceDateDataError:
        "Eingriffsdatum konnte nicht gespeichert werden - fehlende Datenkennungen. Bitte laden Sie die Seite neu oder wenden Sie sich an den Support, wenn das Problem weiterhin besteht.",
    referenceDateMinMessage: "Wählen Sie ein Datum, das höchstens 2 Jahre in der Vergangenheit liegt.",
    referenceDateMaxMessage: "Wählen Sie ein Datum, das höchstens 2 Jahre in der Zukunft liegt.",
    referenceDateQuestion: (kind) => {
        if (kind === "product") return "Behandlungsbeginn";
        if (kind === "injection") return "An welchem Datum hatten oder haben Sie die Injektion?";
        if (kind === "surgery") return "An welchem Datum hatten oder haben Sie die Operation?";
        if (kind === "medication") return "An welchem Datum haben Sie mit der Medikation begonnen oder beginnen Sie?";
        if (kind === "shockwave")
            return "An welchem Datum haben Sie mit der Stoßwellentherapie begonnen oder beginnen Sie?";
        if (kind === "consultation") return "An welchem Datum hatten oder haben Sie die Beratung?";
        return "An welchem Datum hatten oder haben Sie die Behandlung?";
    },
    referenceDateDescriptionFor: (phrase, kind) => {
        if (kind === "product") {
            return `Wann beginnen Sie mit ${phrase} (oder haben Sie begonnen)? Bitte geben Sie an, wann Ihre Behandlung begonnen hat oder beginnen wird. So können wir Ihnen die passenden Folgefragen stellen.`;
        }
        if (kind === "injection") {
            return `Wählen Sie das Datum Ihrer Injektion - vergangen oder bevorstehend - damit Ihre Folgefragen dazu passen.`;
        }
        if (kind === "shockwave") {
            return `Wählen Sie das Datum Ihrer Stoßwellentherapie - vergangen oder bevorstehend - damit Ihre Folgefragen dazu passen.`;
        }
        if (kind === "surgery") {
            return `Wählen Sie das Datum Ihrer ${phrase} - vergangen oder bevorstehend - damit Ihre Folgefragen dazu passen.`;
        }
        if (kind === "consultation") {
            return `Wählen Sie das Datum Ihrer Beratung - vergangen oder bevorstehend - damit Ihre Folgefragen dazu passen.`;
        }
        return `Wählen Sie das Datum Ihrer ${phrase} - vergangen oder bevorstehend - damit Ihre Folgefragen dazu passen.`;
    },
    productStartDateLabel: (phrase) => `Beginn der ${phrase}-Behandlung`,
    chooseDateError: (phrase) => `Bitte wählen Sie das Datum Ihrer ${phrase}`,
    chooseProductStartDateError: (phrase) => `Bitte wählen Sie, wann Sie mit ${phrase} begonnen haben`,
    savedProcedureDateToast: (phrase) => `Ihr ${phrase}-Datum wurde gespeichert.`,
    savedProductStartDateToast: (phrase) => `Ihr Startdatum für ${phrase} wurde gespeichert.`,
};
